import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Lock, Loader2, Check, Home } from 'lucide-react';
import { supabase } from '../lib/supabase';
import toast from 'react-hot-toast';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Supabase reset-confirm akışı tarayıcıda geçici session açar; güncelledikten sonra çıkış yapıp login'e yönlendiriyoruz
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      await supabase.auth.signOut();
      toast.success('Şifre başarıyla güncellendi. Lütfen yeni şifrenizle giriş yapın.');
      navigate('/login');
    } catch (err) {
      toast.error(err.message || 'İşlem başarısız');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 flex items-center justify-center px-4">
      <div className="max-w-md w-full backdrop-blur-xl bg-white/10 rounded-3xl p-8 shadow-2xl border border-white/20 relative">
        {/* Home Icon - Sağ Üst */}
        <Link
          to="/"
          className="absolute top-6 right-6 group p-2 bg-white/20 backdrop-blur-sm border border-white/30 rounded-xl hover:bg-white/30 hover:shadow-lg transform hover:scale-110 transition-all duration-300"
        >
          <Home className="h-5 w-5 text-white group-hover:text-white/90" />
        </Link>

        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-emerald-500 to-teal-600 rounded-2xl mb-4 shadow-lg">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold text-white">Yeni Şifre Belirle</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-medium text-white/90 mb-2">Yeni şifre</label>
            <input
              type="password"
              required
              minLength={6}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-white/10 border border-white/20 rounded-2xl text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/40 focus:border-white/40"
              placeholder="••••••••"
            />
          </div>
          <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center py-3 rounded-2xl text-white font-semibold bg-gradient-to-r from-emerald-600 to-teal-600 hover:from-emerald-700 hover:to-teal-700 transition disabled:opacity-50">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : <><Check className="h-5 w-5 mr-2" /> Şifreyi Güncelle</>}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;


